import { Component, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { Router, ActivatedRoute } from "@angular/router";
import { DashboardService } from '../dashboard/dashboard.service';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as FileSaver from 'file-saver';
import { MatDialog } from '@angular/material/dialog';
import { CcEmailAndSmsComponent } from '../dashboard/cc-email-and-sms/cc-email-and-sms.component';
import { SharedService } from '../services/shared.service';
import { S3Service } from '../services/s3.service';
import { PdfViewerModalComponent } from '../pdf-viewer-modal/pdf-viewer-modal.component';
import { DomSanitizer } from '@angular/platform-browser';
import { Lightbox } from 'ngx-lightbox';
import * as moment from 'moment-timezone';
import { environment } from 'src/environments/environment';
import { parsePhoneNumber, AsYouType, isValidPhoneNumber } from 'libphonenumber-js';
@Component({
  selector: 'app-export-action-list',
  templateUrl: './export-action-list.component.html',
  styleUrls: ['./export-action-list.component.scss']
})
export class ExportActionListComponent implements OnInit {
  showExport = false;
  actionListTypes = {
    actionListName: "LIST NAME",
    time: "TIME",
    formName: "FORM NAME",
    topic: "TOPIC",
    subTopic: "SUBTOPIC",
    sender: "SENDER",
    subject: "COMMENTS",
    photos: "PHOTOS",
    files: "FILES",
    all: "ALL DETAILS"
  }
  selectedData = {
    actionListName: "LIST NAME",
    time: "TIME",
    formName: "FORM NAME",
    topic: "TOPIC",
    subTopic: "SUBTOPIC",
    sender: "SENDER",
    subject: "COMMENTS",
    photos: "PHOTOS",
    files: "FILES"
  };
  forms: any;
  actionType = '';
  includeHeaders = true;
	bgTextColor = "#000000";
  preview = "";
  timezone;
  moment = moment;
  environment = environment;

  constructor(
    private _dashboardService: DashboardService,
    private activatedRoute: ActivatedRoute,
    private _location: Location,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private _sharedService: SharedService,
    private _s3Service: S3Service,
    private _domSanitizer: DomSanitizer,
    private _lightbox: Lightbox
  ) { }

  ngOnInit(): void {
    this.timezone = localStorage.getItem('timezone') || environment.data_time_timezone;
		if (localStorage.getItem('bgTextColor')) this.bgTextColor = localStorage.getItem("bgTextColor");
    this.actionType = localStorage.getItem('actionType');
    this.activatedRoute.paramMap.subscribe(params => {
      if (params.get('id')) {

        this._dashboardService.getSubmittedFormsOfActionType(localStorage.getItem('organization'), params.get('id')).subscribe((response) => {
          if (response['success']) {
            this.actionType = response["data"]["name"];
            if (response['data']['documents'] && response['data']['documents'].length > 0) {
              this.forms = response['data']['documents'];
              _.forEach(this.forms, (form) => {
                form["photos"] = [];
                form["files"] = [];
                if (!form["subTopics"] || form["subTopics"].length === 0) {
                  form["subTopics"] = "-"
                }
                if(this.timezone) {
                  form['sortTime'] = moment(form['sortTime']).tz(this.timezone).format('llll')
                }
                form.templateSchema = form.template && form.template.template_schema && form.template.template_schema.schema ? form.template.template_schema.schema : [];
                _.forEach(form.template.template_schema.schema, (field) => {
                  if (field.type === "picture") {
                    let formResponse = form.response;
                    let keys = formResponse[field.key];
                    if (keys && keys.length > 0) {
                      keys.forEach((key) => {
                        this._s3Service.getObjectFromKey(key).subscribe((result) => {
                          if (response && Object.keys(response["data"]).length > 0) {
                            var binary = '';
                            var bytes = new Uint16Array(result['data']);
                            var len = bytes.byteLength;
                            for (var i = 0; i < len; i++) {
                              binary += String.fromCharCode(bytes[i]);
                            }
                            let image = "data:image/jpeg;base64," + window.btoa(binary);
                            form["photos"].push({ src: image, thumb: image });
                          }
                        }, (error) => {
                          console.log(error);
                        });
                      });
                    }
                  } else if (field.type === "file") {
                    let formResponse = form.response;
                    let keys = formResponse[field.key];
                    if (keys && keys.length > 0) {
                      keys.forEach((key) => {
                        this._s3Service.getObjectFromKey(key).subscribe((result) => {
                          if (response && Object.keys(response["data"]).length > 0) {
                            var binary = '';
                            var bytes = new Uint8Array( result["data"] );
                            var len = bytes.byteLength;
                            for (var i = 0; i < len; i++) {
                              binary += String.fromCharCode( bytes[ i ] );
                            }
                            const url = this._domSanitizer.bypassSecurityTrustResourceUrl(window.URL.createObjectURL(new Blob([new Uint8Array(atob(window.btoa(binary)).split('').map(char => char.charCodeAt(0)))], { type: 'application/pdf'})));
                            form['files'].push(url)
                          }
                        }, (error) => {
                          console.log(error);
                        });
                      });
                    }
                  } else if(field.type === "select" && field.key !== 'topic' && field.key !== 'subtopic' && field.key !== 'subtopic') {
                    if(form.response[field.key] && Object.values(form.response[field.key]) && Object.values(form.response[field.key]).length) {
                      form.response[field.key]['value'] = Object.values(form.response[field.key])[0];
                    }
                  }
                });
              });
            }
          }
        }, (error) => {
          console.log(error);
        });
      }
    });
  }

  ngAfterViewChecked() {
		if (this.check(this.bgTextColor)) {
			this._sharedService.updateHomeColor(this.bgTextColor);
		}
	}

  check(hex) {
		if (/[0-9A-F]{6}$/i.test(hex)) {
			return true;
		}
	}

  saveValue(list, event) {
    if (event.currentTarget.checked) this.selectedData[list['key']] = list['value'];
    else {
      if (Object.keys(this.selectedData).length > 0) delete this.selectedData[list['key']];
    }
    (!this.selectedData || Object.keys(this.selectedData).length === 0) ? this.preview = "false" : this.preview = "true";
  }

  setHeaders() {
    this.includeHeaders = !this.includeHeaders;
  }

  getData(form, key) {

    if (key === 'topic') {
      if (form.sortTopics) {
        return Object.values(form.sortTopics)[0];
      } else {
        return "";
      }
    } else if (key === 'subTopic') {
      if (form.subTopics) {
        return Object.values(form.subTopics)[0];
      } else {
        return "";
      }
    }
  }

  originalOrder = (): number => {
    return 0;
  }

  trackById = (ind, obj) => {
    return obj;
  }

  navigateBack = () => {
    this._location.back();
  }

  downloadPdf(): void {
    if (this.forms.length === 0) {
      this.openSnackBar("No forms found");
      return;
    }
    let link = window.location.pathname.split("/");
    //window.open("/download/pdf/" + localStorage.getItem('organization') + "/" + link[2]);

    if (Object.keys(this.selectedData).length === 0) { 
      this.openSnackBar("Please select item which you want to export.") 
      return;
    }

    let request = { 
      orgId: localStorage.getItem('organization'),
      actionType: link[3], 
      actionListName: this.actionType, 
      filter: Object.keys(this.selectedData),
      includeHeaders: this.includeHeaders, 
      timezone: environment.data_time_timezone || Intl.DateTimeFormat().resolvedOptions().timeZone 
    };
    
    this._dashboardService.exportPDF(request)
      .subscribe((response) => {
        var blob = new Blob([response['body']], { type: "application/pdf;charset=utf-8" });
        var fileName = this.actionType;
        FileSaver.saveAs(blob, fileName);
      }, (error) => {
        console.log(error);
        if(error.status == 400) {
          this._sharedService.openSnackBar("No data to download PDF.");
        }
      });
  }


  downloadExcel(): void {
    if (this.forms.length === 0) {
      this.openSnackBar("No forms found");
      return;
    }

    if (Object.keys(this.selectedData).length === 0) { 
      this.openSnackBar("Please select item which you want to export.") 
      return;
    }

    let link = window.location.pathname.split("/");
    //window.open("/download/pdf/" + localStorage.getItem('organization') + "/" + link[2]);
    let keys = Object.keys(this.selectedData);
    let index = keys.indexOf('photos');
    (index > -1) ? keys.splice(index, 1): "";

    let formIds = this.forms.map((form) => {
      return form._id;
    })

    this._dashboardService.exportExcel({ 
      orgId: localStorage.getItem('organization'), 
      actionType: link[3], 
      actionListName: this.actionType, 
      filter: keys,
      includeHeaders: this.includeHeaders, 
      forms: formIds, 
      timezone: environment.data_time_timezone || Intl.DateTimeFormat().resolvedOptions().timeZone })
      .subscribe((response) => {
        var blob = new Blob([response['body']], { type: "application/xlsx" });
        var fileName = this.actionType + '.xlsx';
        FileSaver.saveAs(blob, fileName);
      }, (error) => {
        console.log(error);
        if(error.status == 400) {
          this._sharedService.openSnackBar("No Data to Download Excel.");
        }
      });
  }

  sendBulkEmail(): void {
    if (this.forms.length === 0) {
      this.openSnackBar("No forms found");
      return;
    }

    if (Object.keys(this.selectedData).length === 0) { 
      this.openSnackBar("Please select item which you want to export.") 
      return;
    }
    
    const dialogRef = this.dialog.open(CcEmailAndSmsComponent, {
      width: '400px',
      data: {
        type: "email"
      }
    });
    dialogRef.afterClosed().subscribe((response) => {
      if (response["result"]) {
        let data = response["data"];
        let message = response["message"];
        if (data.length === 0) {
          this.openSnackBar("Please add emails to send email");
          return;
        }
        let link = window.location.pathname.split("/");
        let requestData = {
          organizationId: localStorage.getItem("organization"),
          actionTypeId: link[3],
          data: data,
          actionListName: this.actionType, 
          filter: Object.keys(this.selectedData),
          includeHeaders: this.includeHeaders,
          message: message,
          timezone: environment.data_time_timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
        }
        this._dashboardService.sendBulkEmail(requestData).subscribe((response) => {
          if (response && response["message"]) {
            this.openSnackBar(response["message"]);
          }
        }, (error) => {
          console.log(error);
          this._sharedService.openSnackBar(error.error.message);
        });
      }
    });
  }

  openSnackBar(message) {
    this._snackBar.open(message, "Ok", {
      duration: 2000
    });
  }

  viewFile(files, index): void {
		const dialogRef = this.dialog.open(PdfViewerModalComponent, {
			width: '800px',

			data: {
				file: files[index]
			}
		});
	}

  open(index: number, images): void {
		this._lightbox.open(images, index);
	}

  formatPhone(phone: string) {
    let value = parsePhoneNumber(phone, "US");
    let nationalNumber = value.formatNational();
    return nationalNumber;
  }
}
